import { useContext, useEffect, useRef, useState } from 'react';
import WindowConfigContext from '../context/window-config-context';
import WindowStateContext from '../context/window-state-context';
import { config } from '../helpers/constants';
import useOnChange from './useOnChange';
import useOnKeyDown from './useOnKeyDown';
import usePrevious from './usePrevious';
export default function useAnimatedTextItem(itemId) {
    var _a = useState(''), value = _a[0], setValue = _a[1];
    var prev = usePrevious(value);
    var stateFromEnv = useContext(WindowStateContext);
    var toBeSet = useRef();
    var _b = useState(0), animateIndex = _b[0], setAnimateIndex = _b[1];
    var onChange = useOnChange(itemId, setValue).onChange;
    var onKeyDown = useOnKeyDown(itemId).onKeyDown;
    var animate = useContext(WindowConfigContext).animate;
    var valuesFromEnv = stateFromEnv.fields;
    useEffect(function () {
        if (valuesFromEnv && valuesFromEnv[itemId]) {
            if (prev === undefined || valuesFromEnv[itemId] === undefined) {
                setValue(valuesFromEnv[itemId]);
            }
            else if (!config.DoAnimateTyping) {
                setValue(valuesFromEnv[itemId]);
            }
            else if (prev + '' !== valuesFromEnv[itemId] + '') {
                toBeSet.current = valuesFromEnv[itemId] + '';
                setAnimateIndex((valuesFromEnv[itemId] + '').length);
            }
        }
        else {
            setValue('');
        }
    }, [valuesFromEnv]);
    useEffect(function () {
        if (animate) {
            if (animateIndex > 0 && toBeSet && toBeSet.current) {
                setValue(toBeSet.current.slice(0, -1 * animateIndex + 1 || undefined));
            }
            if (toBeSet && toBeSet.current && animateIndex - 1 > 0) {
                setTimeout(function () {
                    setAnimateIndex(function (animateIndex) { return animateIndex - 1; });
                }, config.ButtonTypeAnimationDelay);
            }
        }
    }, [animateIndex]);
    return { value: value, onChange: onChange, onKeyDown: onKeyDown, setValue: setValue };
}
//# sourceMappingURL=useAnimatedTextItem.js.map